import { createAction } from 'redux-actions';

export const displayError = createAction('DISPLAY_ERROR');
export const clearError = createAction('CLEAR_ERROR');

export const displayErrorDialog = createAction('DISPLAY_ERROR_DIALOG');
export const clearErrorDialog = createAction('CLEAR_ERROR_DIALOG');
